export default function user(state = {}) {
  return {
    id: 1,
    name: "Bhavani Singh",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTjzJjPa-3jdL6XAI0yqXBY8VzK_p5h0yQIkQ&usqp=CAU",
  };
}
